// ABOUTME: Entry point for the client portal React application
// ABOUTME: Mounts the root App component with the QueryClient provider and Honeybadger reporting
import ReactDOM from 'react-dom/client';
import { configureHoneybadger, notifyCaughtRenderError } from './Honeybadger';
import { reloadOnConsentWithdrawal, removeDeniedCookies } from './Osano';
import App from './components/App';
import { QueryClientProvider } from './providers/QueryClientProvider';
import './index.css';

configureHoneybadger();
reloadOnConsentWithdrawal();
removeDeniedCookies();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
  onCaughtError: notifyCaughtRenderError,
}).render(
  <QueryClientProvider>
    <App />
  </QueryClientProvider>,
);
